import React from 'react';
import { Link } from 'react-router-dom';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import './Common.scss';

const SideMenu: React.FC = () => {
  return (
    <div className="admin-sidebar">
      <h5 className="mb-3 text-center">管理メニュー</h5>
      <Accordion allowZeroExpanded={true}>
        {/* 管理者ページトップ */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>📊 管理者ページトップ</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                トップ
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* ユーザ管理メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>👥 ユーザ管理</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/users"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                ユーザ一覧
              </Link>
              {/* 将来的な拡張用 */}
              {/* <Link 
                                to="/admin/user-create" 
                                className="text-decoration-none d-block p-2 hover-bg-light"
                            >
                                ユーザ作成
                            </Link> */}
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* お問い合わせ管理メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>✉️ お問い合わせ</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/contacts"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                お問い合わせ一覧
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* 受付時間管理メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>🕒 受付時間</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/available-times"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                受付時間一覧
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* 予約管理メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>🕒 予約管理</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/reservations"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                予約一覧
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* 記事管理メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>📝 記事管理</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/articles"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                記事一覧
              </Link>
              <Link
                to="/admin/articles/new"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                新規記事作成
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>

        {/* 設定メニュー */}
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>⚙️ 設定</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="p-2">
              <Link
                to="/admin/settings"
                className="text-decoration-none d-block p-2 hover-bg-light"
              >
                システム設定
              </Link>
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default SideMenu;
